module.exports = __webpack_public_path__ + "static/media/light5.579cce86.jpg";